export default __webpack_public_path__ + "static/media/ep20.df55a36b.jpeg";